import { Backdrop } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GENERAL__CANCEL_BUTTON, GENERAL__YES, WAGE_INDEXATION__CONFIRM_INDEXATION } from 'translations/constants';
import { ModalActionButton, ModalActionContainer, ModalContainer, ModalTitle, WageIndexationModal } from './styles';

const ConfirmIndexationModal = ({ isOpen, onClose, onConfirm }) => {
  const [t] = useTranslation();

  return (
    <Backdrop open={isOpen} sx={{ zIndex: '2000' }}>
      <WageIndexationModal open={isOpen} onClose={onClose}>
        <ModalContainer>
          <ModalTitle>{t(WAGE_INDEXATION__CONFIRM_INDEXATION)}</ModalTitle>
          <ModalActionContainer>
            <ModalActionButton text={t(GENERAL__YES)} onClick={onConfirm} />
            <ModalActionButton text={t(GENERAL__CANCEL_BUTTON)} outlined onClick={onClose} />
          </ModalActionContainer>
        </ModalContainer>
      </WageIndexationModal>
    </Backdrop>
  );
};

export default ConfirmIndexationModal;
